export default class Troops {
	static TRIBE_NATURE = 4; // (свое значение)
	
	static TYPE_SETTLER = 10; // поселенец
	static TYPE_HERO = 11; // герой
	
	static MOVEMENT_TYPE_ATTACK = 3; // атака
	static MOVEMENT_TYPE_RAID = 4; // набег
	static MOVEMENT_TYPE_SUPPORT = 5; // подкрепление
	static MOVEMENT_TYPE_SPY = 6; // разведка
	static MOVEMENT_TYPE_SETTLE = 10; // поселение
	static MOVEMENT_TYPE_SIEGE = 47; // осада
}
